
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import ProspectClotureForm from '@/components/forms/ProspectClotureForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')

@Component({
  components: {
    BaseCardContainer,
    ProspectClotureForm
  }
})
export default class ProspectCloture extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('updateProspectAction') updateProspect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any

  onSubmit(data: any) {
    this.updateProspect({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      Vue.notify({
        group: 'user',
        type: 'success',
        title: 'Confirmation',
        text: 'Les données ont bien été mises à jour'
      })
      this.$nextTick(() => VueScrollTo.scrollTo('#app'))
    })
  }

  onCancel() {
    this.$router.go(-1)
  }
}
